import './Libraries.scss';
import { RouteComponentProps } from 'react-router';
import React from 'react';
import PageWrapper from '@go-client/pages/PageWrapper';
import Page from '@go-client/pages/Page';
import { MenuBar } from '@go-client/components';
import { BrandLogo } from '@go-client/components/UIkit/Brand/BrandLogo/BrandLogo';
import { PropertyBanner } from '@go-client/components/UIkit/Property/PropertyBanner';
import { BubbleOverlay } from '@go-client/components/BubbleUI';
import { Property } from '@go-shared/types/property';
import { User } from '@go-shared/types/user';
import LibrariesNavigation from '@go-client/components/Navigations/LibrariesNavigation';

interface LibrariesPagePropsBase {
  user: User;
  property: Property;
  loading?: boolean;
  contentRef?: React.MutableRefObject<HTMLDivElement | null>;
  active: 'libraries' | 'assets';
  bodyFn?: () => React.ReactNode;
  headerFn?: () => React.ReactNode;
  sideFn?: () => React.ReactNode;
  outerFn?: () => React.ReactNode;
}

type LibrariesPageProps = LibrariesPagePropsBase & RouteComponentProps;

export default function Libraries(props: LibrariesPageProps) {
  const { user, property, contentRef, bodyFn, headerFn, sideFn, outerFn, loading, ...rest } = props;

  return (
    <PageWrapper {...rest}>
      <Page className="Libraries absolute flex items-stretch">
        <MenuBar {...rest} property={property} />
        <div className="SideMenu flex flex-col bg-titanium-darkest shadow-md">
          <div className="bg-white flex flex-col items-center">
            <BrandLogo logo={property.brand.logo} />
            <PropertyBanner {...rest} property={property} swappable />
          </div>
          {sideFn && sideFn()}
        </div>
        <div
          ref={contentRef}
          className="LibrariesContent bg-blue-lightest overflow-y-auto flex-grow"
        >
          <div
            className="LibrariesHeader align-with-logo flex items-end px-5 sticky top-0
              left-0 z-10 bg-blue-lightest"
          >
            <div className="mb-3 pl-3 flex-grow flex items-end">
              <LibrariesNavigation active={props.active} />
            </div>
            <div
              className="absolute w-full bg-blue-lightest flex border-blue-lightest -mx-5 px-5"
              style={{
                height: 'calc(40px + 0.75rem)',
                bottom: 'calc(-40px - 0.75rem)',
                borderBottomWidth: '0.75rem',
                zIndex: 10,
              }}
            >
              {headerFn && headerFn()}
            </div>
          </div>
          <div className="LibrariesBody mx-5 content-minus-logo min-w-900">
            <BubbleOverlay loading={loading}>
              <div style={{ marginTop: 'calc(40px + 0.75rem)' }}>{bodyFn && bodyFn()}</div>
            </BubbleOverlay>
            <div className="mt-3">&nbsp;</div>
          </div>
        </div>
        {outerFn && outerFn()}
      </Page>
    </PageWrapper>
  );
}
